import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Service from "./pages/Service";
import Team from "./pages/Team";
import Contact from "./pages/Contact.js";
import Mission from "./helpers/Mission.js";
import Vission from "./helpers/Vission.js";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/mission" element={<Mission />} />
          <Route path="/vission" element={<Vission />} />
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/services" element={<Service />} />
          <Route path="/our-team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
       
      </Router>
    </div>
  );
}

export default App;
